import { Status } from "./constants";
import { Protocol } from "./constants";
import { logger } from "./logger";

export class WS {
  reconnectTimeout = 0;
  pingInterval = 0;
  msg_buffer = "";
  count = 0

  game_object = null;
  websocket = null;
  interfaceReq = [
    { name: "WS_URL", type: "string", fatal: true },
    { name: "doMessage", type: "function", fatal: true },
    { name: "setStatus", type: "function", fatal: true }
  ];

  Init(_game) {
    this.game_object = _game;

    if (this.game_object === null) {
      throw new Error("Game Object is null");
    }

    this.interfaceReq.forEach(item => {
      if (typeof this.game_object[item.name] !== item.type) {
        if (item.fatal) {
          throw new Error("Game." + item.name + " is not defined");
        } else {
          logger.log(
            "Game." +
            item.name +
            " is not defined, you will not receive this event"
          );
        }
      }
    });

    return this;
  }

  Start() {
    if (this.game_object.WS_URL.includes('orbitalgaming.com')) {
      console.clear()
      logger.isEnabled = false
    }

    logger.log("Start websocket to " + this.game_object.WS_URL);
    try {
      var _this = this;
      this.websocket = new WebSocket(this.game_object.WS_URL);

      this.websocket.onerror = function (evt) {
        _this.onerror(evt);
      };
      this.websocket.onopen = function (evt) {
        _this.onopen(evt);
      };
      this.websocket.onmessage = function (evt) {
        _this.onmessage(evt);
      };
      this.websocket.onclose = function (evt) {
        _this.onerror(evt);
      };
    } catch (err) {
      logger.log(err);
    }
    return this;
  }

  sendMessage(msg) {
    if (msg !== Protocol.PING) {
      this.count = 0
      logger.log("%c^^^^^ OUTGOING MSG ^^^^^^", "color : orange", msg);
    }

    if (this.websocket.readyState === WebSocket.OPEN) {
      this.websocket.send(msg + Protocol.END_MESSAGE);
    }
    // else {
    //   clearTimeout(this.reconnectTimeout);
    //   clearInterval(this.pingInterval);
    //   var self = this;
    //   this.reconnectTimeout = setTimeout(function() {
    //     self.reconnect();
    //   }, 3000);
    // }
  }

  pingIntervalFunc(self) {
    self.count++
    if (self.count === 60) {
      self.Disconnect()
    }
    self.sendMessage(Protocol.PING)
  }


  // reconnect() {
  //   clearInterval(this.pingInterval);
  //   this.websocket.onerror = null;
  //   this.websocket.onopen = null;
  //   this.websocket.onmessage = null;
  //   this.websocket.onclose = null;
  //   this.Start();
  // }

  onerror(evt) {
    this.game_object.setStatus(Status.DISCONNECTED);

    logger.log("onerror ", evt);
    clearTimeout(this.reconnectTimeout);
    clearInterval(this.pingInterval);
    // var self = this;
    // this.reconnectTimeout = setTimeout(function() {
    //   self.reconnect();
    // }, 3000);
  }

  Disconnect() {
    clearInterval(this.pingInterval);
    clearTimeout(this.reconnectTimeout);
    this.game_object.setStatus(Status.DISCONNECTED);

    this.websocket.onerror = null;
    this.websocket.onopen = null;
    this.websocket.onmessage = null;
    this.websocket.onclose = null;
    this.msg_buffer = "";
    this.websocket.close();
  }

  onopen(evt) {
    this.game_object.setStatus(Status.CONNECTED);
    this.pingInterval = setInterval(
      this.pingIntervalFunc.bind(null, this),
      5000
    );
  }

  onmessage(evt) {
    var msg = evt.data;
    this.msg_buffer += msg;

    if (this.msg_buffer.indexOf(Protocol.END_MESSAGE) !== -1) {
      var splited = this.msg_buffer.split(Protocol.END_MESSAGE);

      splited.forEach(item => {
        if (item.length > 0) this.game_object.doMessage(item);
      });

      this.msg_buffer = splited[splited.length - 1];
    }
  }
}

// export default WS;
